import { lazy } from 'react';

const list = lazy(() => import('pages/shipmentAccounts/List'));

export { list };
